import type { Suggestion } from '~/contracts';
import {
  type SavedSearchWithText,
  type SuggestionButton,
  type SuggestionItem
} from './hooks';

export function isButton(item: SuggestionItem): item is SuggestionButton {
  return (item as SuggestionButton).element != null;
}

export function isSavedSearch(
  item: SuggestionItem
): item is SavedSearchWithText {
  return (item as SavedSearchWithText).url != null;
}

export function isSuggestion(item: SuggestionItem): item is Suggestion {
  return (item as Suggestion).filters != null;
}

export function isSavedSuggestion(item: SuggestionItem): item is Suggestion {
  return (item as Suggestion).isSavedSuggestion === true;
}
